import React from 'react'
import ReactDOM from 'react-dom/client'
import { msalInstance } from '@/features/auth/lib/msalConfig'
import { bootstrapAuth } from '@/features/auth/lib/bootstrapAuth'
import { initAppInsights } from '@/shared/lib/telemetry'
import AppProviders from '@/app/providers/AppProviders'
import App from '@/app/App'
import { renderBootstrapError } from '@/app/renderBootstrapError'
import '@/app/styles/index.css'

const container = document.getElementById('root')!

bootstrapAuth()
  .then(() => {
    initAppInsights()

    ReactDOM.createRoot(container).render(
      <React.StrictMode>
        <AppProviders msalInstance={msalInstance}>
          <App />
        </AppProviders>
      </React.StrictMode>,
    )
  })
  // Surface MSAL init failures instead of a silent blank page.
  .catch((err) => renderBootstrapError(container, err))
